"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RadioButton.css");
var RadioGroup_1 = require("./RadioGroup");
var RadioItem_1 = require("./RadioItem");
var Utils = require("player-core/utils");
/**
 * @see RadioButtonProps
 */
var RadioButton = /** @class */ (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton(props) {
        var _this = _super.call(this, props) || this;
        _this._onChange = _this._onChange.bind(_this);
        _this.id = _this.props.id ? _this.props.id : "radio_" + Utils.createUUID();
        return _this;
    }
    RadioButton.prototype._onChange = function (value, id) {
        this.props.onChange && this.props.onChange(value, id);
    };
    RadioButton.prototype._getRadioItems = function () {
        var _this = this;
        var _a = this.props, items = _a.items, selectedValue = _a.selectedValue, buttonAlignment = _a.buttonAlignment, children = _a.children, isEnabled = _a.isEnabled;
        var flatChildren = [].concat.apply([], children); // flatten first level arrays in children
        return (items &&
            items.map(function (item, i) {
                var idValue = _this.id + "_" + item.value;
                var radioItemProps = {
                    id: idValue,
                    name: _this.id,
                    label: item.label,
                    value: item.value,
                    itemEnabled: item.isEnabled,
                    buttonAlignment: item.buttonAlignment || buttonAlignment,
                    isEnabled: isEnabled,
                    selectedValue: selectedValue,
                    key: idValue,
                    onChange: _this._onChange,
                    children: flatChildren && flatChildren[i]
                };
                return React.createElement(RadioItem_1.default, __assign({}, radioItemProps));
            }));
    };
    RadioButton.prototype._getRadioGroupProps = function () {
        var _a = this.props, ariaLabelledBy = _a.ariaLabelledBy, legend = _a.legend, isEnabled = _a.isEnabled, style = _a.style, tag = _a.tag, isInline = _a.isInline, isRequired = _a.isRequired, errorMessage = _a.errorMessage;
        return {
            ariaLabelledBy: ariaLabelledBy,
            legend: legend,
            isEnabled: isEnabled,
            style: style,
            tag: tag,
            id: this.id,
            isInline: isInline,
            isRequired: isRequired,
            errorMessage: errorMessage
        };
    };
    RadioButton.prototype.render = function () {
        return React.createElement(RadioGroup_1.default, __assign({}, this._getRadioGroupProps()), this._getRadioItems());
    };
    RadioButton.defaultProps = {
        id: '',
        legend: '',
        selectedValue: '',
        isEnabled: true,
        items: [],
        style: 'desktop',
        buttonAlignment: 'middle',
        tag: null,
        onChange: void 0,
        children: null,
        errorMessage: '',
        isRequired: false
    };
    return RadioButton;
}(React.Component));
exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/radio-button/build/control/RadioButton.js
// module id = 898
// module chunks = 0